import { TextField } from '@mui/material';
import IncFormHelperText from 'components/forms/inc-form-helper-text/inc-form-helper-text.component';
import { Controller, useFormContext } from 'react-hook-form';
import useCheckAutoFill from 'hooks/use-check-auto-fill';

type UsernameFieldType = {
  name: string;
  label: string;
  helperText?: string;
  autoComplete: string;
};

const UsernameField = ({ name, helperText, ...rest }: UsernameFieldType) => {
  const { control } = useFormContext();

  const [autoFilled, handleCheckAnimation] = useCheckAutoFill();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, ...fieldRest }, fieldState: { error } }) => (
        <TextField
          {...fieldRest}
          inputRef={ref}
          error={!!error}
          helperText={
            <IncFormHelperText error={error} helperText={helperText} />
          }
          onAnimationStart={handleCheckAnimation}
          InputLabelProps={{ shrink: autoFilled || !!fieldRest.value }}
          {...rest}
        />
      )}
    />
  );
};

export default UsernameField;
